import { useQuery } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';
import { consentsQueryOptions } from './consents.query-options';

/**
 * 약관 목록 query — `consentsQueryOptions`(entity SSOT)를 컨텍스트에 적용. app-legacy(v3). 고객센터 약관 목록.
 */
export function useConsentsQuery() {
  const api = useApiAppLegacy();
  return useQuery(consentsQueryOptions(api));
}
